import { useEffect, useState } from "react";
import { policies } from "./policies";

export default function Right({ currentPolicy }) {
  const [activeId, setActiveId] = useState(null);

  let policy = null;
  for (const category of Object.values(policies.categories)) {
    if (category.policies[currentPolicy]) {
      policy = category.policies[currentPolicy];
      break;
    }
  }

  useEffect(() => {
    setActiveId(null);

    const handleScroll = () => {
      const sections = document.querySelectorAll("main section");
      let current = null;

      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= 120 && rect.bottom >= 120) {
          current = section.id;
        }
      });

      setActiveId(current);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [currentPolicy]);

  if (!policy) return null;

  return (
    <aside className="policy-toc">
      <h3>Table of Contents</h3>
      <ul>
        {policy.sections.map(sec => (
          <li
            key={sec.id}
            className={activeId === sec.id ? "active" : ""}
          >
            <a href={`#${sec.id}`}>{sec.title}</a>
          </li>
        ))}
      </ul>
    </aside>
  );
}
